/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import Label from 'components/Form/Label';
import { mediaHelperMaxWidth } from "utils/src";
import { Breakpoints } from 'constants/Breakpoints';

export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  
  `;

export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;

export const Label1 = styled(Label)`
  color: ${Colors.GRAY[0]};
  font-weight: ${FontWeight.Bold};
  font-size: 14px;
`;

export const ContentTextarea = styled.div`
width: 100%;  
margin-top: 0px;
margin-bottom: 0px;
background-color: red;
p{
  color: ${Colors.GRAY[0]};
  margin-bottom: 5px;
  margin-top: 10px;
  font-weight: 800;
  font-size: 14px;
}
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  top: 75px;
  right: 14px;
  position: absolute;
`;

export const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  background-color:#FFF;  
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 30px;
    width: 100%;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`

export const TableRow = styled.tr`

`;

export const TableHeader = styled.th`
  ${({ minWidth }) => minWidth ? `min-width: ${minWidth}px` : ''}
  ${({ maxWidth }) => maxWidth ? `width: ${maxWidth}px` : ''}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  span {
    font-size: 12px !important;
  }
`

export const TableBody = styled.tbody`
    tr {
      border-bottom: 2px solid #E0E0E0;
    }
`;

export const TableCollum = styled.td`
  vertical-align: top;
  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;
    text-align: left;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;


export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 12px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: 600px) {
    display: none;
  }
`;

export const LabelEdit = styled(Label)`
  font-size: 12px;

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  } 
  
`;